export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/8aaaaf398ad569d1c23f27e0063ffe48.jpg"
          alt="Professional Commercial Cleaning"
          className="w-full h-full object-cover object-[center_30%]"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full">
        <div className="flex justify-center mb-8">
          <img
            src="https://static.readdy.ai/image/afaf0eabbceea583753f6e045d53514c/4a78b5f12f124598ea76de217c0e359d.svg"
            alt="Commercial Janitorial Company Logo"
            className="h-40 w-auto"
          />
        </div>
        <h1 className="text-white mb-6">
          <div className="text-7xl font-bold mb-2 tracking-tight">COMMERCIAL CLEANING</div>
          <div className="text-6xl font-serif italic">Solutions You Can Trust</div>
        </h1>
        <p className="text-white/90 text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
          Delivering exceptional commercial cleaning services with trained professionals,
          eco-friendly products, and 24/7 availability for your business
        </p>
        <button
          onClick={scrollToContact}
          className="bg-white text-gray-900 px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-100 transition-all inline-flex items-center gap-2 cursor-pointer whitespace-nowrap shadow-lg"
        >
          <div>Contact</div>
          <i className="ri-arrow-right-line text-xl"></i>
        </button>
      </div>
    </section>
  );
}
